import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=3605681c&scoped=true&"
import script from "./image-viewer.vue?vue&type=script&lang=js&"
export * from "./image-viewer.vue?vue&type=script&lang=js&"
import style0 from "./image-viewer.vue?vue&type=style&index=0&id=3605681c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3605681c",
  null
  
)

export default component.exports